// Brasa de Pasto - interactions
document.addEventListener('click', function(e){
  var add = e.target.closest('[data-add-to-cart]');
  if(!add) return;
  var id = add.getAttribute('data-add-to-cart');
  if(!id){ window.location.href = '/cart'; return; }
  e.preventDefault();
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(id),quantity:1})})
    .then(function(r){return r.json();})
    .then(function(){ window.location.href='/cart'; })
    .catch(function(){ window.location.href='/cart'; });
});

// Mobile nav toggle
(function(){
  var toggle = document.getElementById('navToggle');
  var menu = document.getElementById('mobileNav');
  if(!toggle || !menu) return;
  toggle.addEventListener('click', function(){
    var open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  });
  menu.addEventListener('click', function(e){
    if(e.target.closest('a')){
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
      toggle.setAttribute('aria-label','Abrir menú');
      menu.setAttribute('aria-hidden','true');
    }
  });
})();
